import React from "react";
import {
  Button,
  HelpDrawerToggle,
  HelpDrawer,
  CloseIconThin,
} from "@cmsgov/ds-medicare-gov";
import { Routes } from "../../app";
import { RouteComponentProps } from "react-router";
import { SearchResultsState } from "./useSearchResultsHelper";
import { useTranslate } from "../../helpers";

interface OMHDProps extends RouteComponentProps {
  pageState: SearchResultsState;
  updatePageState: (x: Partial<SearchResultsState>) => void;
}

const OriginalMedicareHelpDrawer: React.FC<OMHDProps> = ({
  pageState,
  updatePageState,
  ...props
}) => {
  const t = useTranslate();

  return (
    <div className="mct-u-width--full">
      <HelpDrawerToggle
        helpDrawerOpen={pageState.showOriginalMedicareDrawer}
        showDrawer={(): void =>
          updatePageState({ showOriginalMedicareDrawer: true })
        }
      >
        {t("search_results_page.see_original_medicare_coverage")}
      </HelpDrawerToggle>
      {pageState.showOriginalMedicareDrawer && (
        <div className="mct-c-help-drawer">
          <HelpDrawer
            heading={t("search_results_page.see_original_medicare_coverage")}
            onCloseClick={(): void =>
              updatePageState({ showOriginalMedicareDrawer: false })
            }
            closeButtonText={<CloseIconThin />}
          >
            <p>
              <b>{t("search_results_page.original_medicare_includes")}</b>{" "}
              {t("search_results_page.original_medicare_includes_hospital")}
            </p>

            <ul>
              <li>
                {t("search_results_page.original_medicare_drug_coverage")}
              </li>
              <li>{t("search_results_page.original_medicare_medigap")}</li>
            </ul>

            <Button
              variation="primary"
              className="ds-u-margin-top--7"
              onClick={(): void => {
                updatePageState({
                  includeOriginalMedicare: true,
                  showOriginalMedicareDrawer: false,
                });
              }}
            >
              {t("search_results_page.see_original_medicare")}
            </Button>
          </HelpDrawer>
        </div>
      )}
      <Button
        variation="transparent"
        className="ds-u-padding--0"
        onClick={(): void => {
          props.history.push(
            `${Routes.sanctionedPlans}${props.location.search}`
          );
        }}
      >
        {t("sanctioned_plans_page.view_sanctioned_plans")}
      </Button>
    </div>
  );
};

export default OriginalMedicareHelpDrawer;
